import React from 'react';
import styled from 'styled-components';
import HeadlessTextArea from '../headless/textarea/HeadlessTextArea';
import { TextAlignment } from '../../enum/EnumRepository';
import { StyledTextAreaComponent } from '../../dto/StyleCompRepository';
import { useStandardAlertStore } from '../../store/portal/alertStore';

//isEditMode에 따라 HeadlessTextAread와 바뀌어야 하고
//visible에 따라 보이든 안보이든 해야함
//alignment에 따라 정렬해야함
interface OrgDescriptionProps {
  value: string;
  handleChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  StyledTextarea: StyledTextAreaComponent;
  alignment?: TextAlignment;
  maxLength?: number;
}

const OrgDescription: React.FC<OrgDescriptionProps> = ({
  value,
  handleChange,
  StyledTextarea,
  alignment,
  maxLength
}) => {
  const { setTextLengthExceededAlert } = useStandardAlertStore();

  const handleChangeWithLimit = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (maxLength && e.target.value.length > maxLength) {
      setTextLengthExceededAlert(maxLength);
      return;
    }
    handleChange(e);
  }

  return (
    <OrgWrapper>
      {maxLength && (
        <LimitDiv>
          {value.toString().length} / {maxLength}
        </LimitDiv>
      )}
      <HeadlessTextArea
        alignment={alignment ? alignment : TextAlignment.LEFT}
        content={value}
        placeholder="Enter message"
        handleChange={maxLength ? handleChangeWithLimit : handleChange}
        StyledTextArea={StyledTextarea}
      />
    </OrgWrapper>
  );
};

export const OrgWrapper = styled.div`
  position: relative;
  display: flex;
`;

const LimitDiv = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  color: ${({ theme }) => theme.colors.color_Gray_05};
  ${({ theme }) => theme.typography.Body_04};
  user-select: none;
  z-index: 2;
`;

export default OrgDescription;
